import { Navigate, useLocation } from "react-router-dom"
import { hasActiveSession } from "../lib/auth"

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  if (!hasActiveSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return children
}
